export default __webpack_public_path__ + "static/media/titanium-app-icon.f29b444b.png";